/*eslint no-magic-numbers: ["error", { "ignore": [0,1, -1] }]*/
/* eslint-disable */
import React, { useContext, useEffect, useRef, useState, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'

import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import AddNewIcon from 'assets/icons/add-new'
import SpeciesParameter from './SpeciesParameter'
import { requestDeleteSiteSpecieAssesmentParameter } from 'api/siteSpecieAssesmentParameter'
import { requestUpdateSiteSpecie } from 'api/siteSpecie'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'
import Textarea from 'components/Textarea'
import MultiSelectionDropdown from 'components/MultiSelectDropdown'
import Select from 'components/Select'
import { SiteContext } from 'providers/site'
import { delay } from 'utils/delay'
import Checkbox from 'components/Checkbox'

import {
  AssessmentPageSubTittle,
  AssessmentPageSubTittleIconWrapper,
  AssessmentPageSubTittleWrapper,
  AssessmentPageTittle,
  AssessmentPageTittleWrapper
} from '../../../../style'
import {
  SpeciesDetailsAddParameter,
  SpeciesDetailsContainer
} from '../style'
import { congregatoryGroupOptions } from 'constants/parametersOptions'

const IrreversibleIndex = 7
const ReversibleIndex = 8
const qualifyIndex = 0
const reasonDefaultOptions = [
  { label: 'Qualifies', value: 1, disabled: false },
  { label: 'Improved site information', value: 2, disabled: false },
  { label: 'KBA criteria revision', value: 3, disabled: false },
  { label: 'Taxonomic revision', value: 4, disabled: false },
  { label: 'Revision to Red List status', value: 5, disabled: false },
  { label: 'Revision of global threshold', value: 6, disabled: false },
  { label: 'No longer geographically restricted', value: 7, disabled: false },
  { label: 'Genuine decline, irreversible', value: 8, disabled: false },
  { label: 'Genuine decline, reversible', value: 9, disabled: false },
  { label: 'Genuine decline, other factors', value: 10, disabled: false }
]

const reasonQualifyOptions = [
  { label: 'Qualifies', value: 1, disabled: false },
  { label: 'Improved site information', value: 2, disabled: true },
  { label: 'KBA criteria revision', value: 3, disabled: true },
  { label: 'Taxonomic revision', value: 4, disabled: true },
  { label: 'Revision to Red List status', value: 5, disabled: true },
  { label: 'Revision of global threshold', value: 6, disabled: true },
  { label: 'No longer geographically restricted', value: 7, disabled: true },
  { label: 'Genuine decline, irreversible', value: 8, disabled: true },
  { label: 'Genuine decline, reversible', value: 9, disabled: true },
  { label: 'Genuine decline, other factors', value: 10, disabled: true }
]

const reasonNonQualifyOptions = [
  { label: 'Qualifies', value: 1, disabled: true },
  { label: 'Improved site information', value: 2, disabled: false },
  { label: 'KBA criteria revision', value: 3, disabled: false },
  { label: 'Taxonomic revision', value: 4, disabled: false },
  { label: 'Revision to Red List status', value: 5, disabled: false },
  { label: 'Revision of global threshold', value: 6, disabled: false },
  { label: 'No longer geographically restricted', value: 7, disabled: false },
  { label: 'Genuine decline, irreversible', value: 8, disabled: false },
  { label: 'Genuine decline, reversible', value: 9, disabled: false },
  { label: 'Genuine decline, other factors', value: 10, disabled: false }
]

const reasonOptionsIrreversibleSelected = [
  { label: 'Qualifies', value: 1, disabled: true },
  { label: 'Improved site information', value: 2, disabled: false },
  { label: 'KBA criteria revision', value: 3, disabled: false },
  { label: 'Taxonomic revision', value: 4, disabled: false },
  { label: 'Revision to Red List status', value: 5, disabled: false },
  { label: 'Revision of global threshold', value: 6, disabled: false },
  { label: 'No longer geographically restricted', value: 7, disabled: false },
  { label: 'Genuine decline, irreversible', value: 8, disabled: false },
  { label: 'Genuine decline, reversible', value: 9, disabled: true },
  { label: 'Genuine decline, other factors', value: 10, disabled: false }
]

const reasonOptionsReversibleSelected = [
  { label: 'Qualifies', value: 1, disabled: true },
  { label: 'Improved site information', value: 2, disabled: false },
  { label: 'KBA criteria revision', value: 3, disabled: false },
  { label: 'Taxonomic revision', value: 4, disabled: false },
  { label: 'Revision to Red List status', value: 5, disabled: false },
  { label: 'Revision of global threshold', value: 6, disabled: false },
  { label: 'No longer geographically restricted', value: 7, disabled: false },
  { label: 'Genuine decline, irreversible', value: 8, disabled: true },
  { label: 'Genuine decline, reversible', value: 9, disabled: false },
  { label: 'Genuine decline, other factors', value: 10, disabled: false }
]

const tooltipXOffset = 0
const tooltipYOffset = 16
const maximumParameterListLength = 24
const inputSaveDelayTime = 300
const updateSensitiveSourceTimeOut = delay(inputSaveDelayTime)

const SpeciesDetailsAssessmentForm = ({
  item,
  getSiteSpecie,
  setItem,
  checkFields,
  site,
  setSiteProposalFieldValidation,
  isEditable
}) => {
  const params = useParams()
  const checkedValue = useRef([])
  const [parameterList, setParameterList] = useState(
    item.SpeciesAssesmentParameters.length ? item.SpeciesAssesmentParameters : [{ id: 'default' }]
  )
  const [qualificationReason, setQualificationReason] = useState(item.triggerReasonId || [])
  const [reassessmentRational, setReassessmentRational] = useState(item.triggerReasonText ? item.triggerReasonText : '')
  const [checkedOptions, setCheckedOptions] = useState(reasonDefaultOptions)
  const [congregatoryGroup, setCongregatoryGroup] = useState(congregatoryGroupOptions.find((element) => {
    return element.value === item.CongregationGroupId
  }) || null)
  // Initialize state - handle both new assessments and reassessments
  // API returns snake_case: sensitive_at_site, sensitive_at_site_source (from DB)
  const [sensitiveAtSite, setSensitiveAtSite] = useState(() => {
    const dbValue = item.sensitive_at_site !== undefined ? item.sensitive_at_site : item.sensitiveAtSite
    return Boolean(dbValue)
  })
  const [sensitiveAtSiteSource, setSensitiveAtSiteSource] = useState(() => {
    const isSensitive = item.sensitive_at_site !== undefined ? item.sensitive_at_site : item.sensitiveAtSite
    if (isSensitive) {
      return item.sensitive_at_site_source !== undefined
        ? (item.sensitive_at_site_source || '')
        : (item.sensitiveAtSiteSource || '')
    }
    return ''
  })
  const { triggerReasonId, updateTriggerReasonId, siteProposalFieldValidation } = useContext(SiteContext)

  const qualified = item.lastReassessmentDate ? item.triggerReasonId.some((element) => {
    // eslint-disable-next-line no-magic-numbers
    return element === 1
  }) : true

  const disabled = site.SiteStatusId !== SITE_STATUS_DRAFT_ID || (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID)

 async function handleChangeQualificationReason(e) {
   try {
     setQualificationReason(e)

     // If the species is disqualified (triggerReasonID > 1), skip capturing the criteria
     if (e > 1) {

       // Update only the disqualification reason without criteria
       await requestUpdateSiteSpecie(item.id, params.siteHistoryId, item.historyId, {
         triggerReasonId: e,
         reassessDateStatus: true,
       })

       return // Exit early to prevent any further processing
     }

     // If the species is not disqualified, proceed with updating the criteria
     await requestUpdateSiteSpecie(item.id, params.siteHistoryId, item.historyId, {
       triggerReasonId: e,
       criteria: item.criteria,
       reassessDateStatus: true,
     })

   } catch {
     // Trigger reason update failed
   }
 }


  function handleChangeValueChecked(Ids) {
    setCheckedOptions(Ids)
    checkedValue.current = Ids
    const isAnyNonQualifyOptionsSelected = Ids.some((item) => {
      return item.checked && item.value !== 1
    })

    if (Ids[IrreversibleIndex].checked) {
      return setCheckedOptions(reasonOptionsIrreversibleSelected)
    }

    if (Ids[ReversibleIndex].checked) {
      return setCheckedOptions(reasonOptionsReversibleSelected)
    }

    if (Ids[qualifyIndex].checked) {
      return setCheckedOptions(reasonQualifyOptions)
    }

    if (isAnyNonQualifyOptionsSelected) {
      return setCheckedOptions(reasonNonQualifyOptions)
    }

    setCheckedOptions(reasonDefaultOptions)
  }

  function handleChangeReassessmentRational(e) {
    setReassessmentRational(e.target.value)

    requestUpdateSiteSpecie(item.id, params.siteHistoryId, item.historyId, { triggerReasonText: e.target.value, reassessDateStatus: true, })
  }

  function addParameter() {
    setParameterList([...parameterList, { id: `parameter${Math.random()}`, isMaturePresent: false }])
  }

  function removeParameter(id) {
    setParameterList(
      parameterList.filter((element) => {
        return element.id !== id
      })
    )

    requestDeleteSiteSpecieAssesmentParameter(id, params.siteHistoryId, item.id, item.historyId).then(() => {
      getSiteSpecie()
    })
  }

  function updateParameterList(updtItem) {
    setParameterList((s) => {
      const tmpCopy = [...s]
      const found = s.findIndex((element) => {
        return element.id === updtItem.id
      })
      tmpCopy[found] = { ...updtItem }
      return tmpCopy
    })
  }

  const handleChangeCongregatoryGroup = (e) => {
    setCongregatoryGroup(e)
    requestUpdateSiteSpecie(item.id, params.siteHistoryId, item.historyId, { CongregationGroupId: e.value, reassessDateStatus: true, })
  }

  const renderParametersList = parameterList.sort((a, b) => {
    if(a.createdAt > b.createdAt) {
      return 1
    } else if (a.createdAt < b.createdAt){
      return -1
    }
    return 0
  }).map((parameter) => {
    return (
      <SpeciesParameter
        key={parameter.id}
        getSiteSpecie={getSiteSpecie}
        speciesId={item.id}
        removeOnCLik={removeParameter}
        parameter={parameter}
        updateParameterList={updateParameterList}
        setItem={setItem}
        checkParameterField={checkFields.numberOfAssessmentParameters}
        species={item}
        site={site}
        qualified={qualified}
        setSiteProposalFieldValidation={setSiteProposalFieldValidation}
        congregatoryGroup={congregatoryGroup}
        handleChangeCongregatoryGroup={handleChangeCongregatoryGroup}
      />
    )
  })

  useEffect(() => {
    if (item.SpeciesAssesmentParameters.length) {
      setParameterList(item.SpeciesAssesmentParameters)
    } else {
      setParameterList([{ id: 'default' }])
    }
  }, [item, setParameterList])


  useEffect(() => {
    const newTriggerReasonId = qualificationReason
    updateTriggerReasonId(newTriggerReasonId);
  }, [qualificationReason, updateTriggerReasonId]);

  useEffect(() => {
    setReassessmentRational(item.triggerReasonText ? item.triggerReasonText : '')
  }, [item.triggerReasonText])

  useEffect(() => {
    setQualificationReason(item.triggerReasonId || [])
  }, [item.triggerReasonId])

  useEffect(() => {
    const newCongregatoryGroup = congregatoryGroupOptions.find((element) => {
      return element.value === item.CongregationGroupId
    }) || null
    setCongregatoryGroup(newCongregatoryGroup)
  }, [item.CongregationGroupId])

  useEffect(() => {
    const dbValue = item.sensitive_at_site !== undefined ? item.sensitive_at_site : item.sensitiveAtSite
    setSensitiveAtSite(Boolean(dbValue))
  }, [item.sensitive_at_site, item.sensitiveAtSite])

  useEffect(() => {
    const isSensitive = item.sensitive_at_site !== undefined ? item.sensitive_at_site : item.sensitiveAtSite
    if (isSensitive) {
      const sourceValue =
        item.sensitive_at_site_source !== undefined
          ? item.sensitive_at_site_source
          : item.sensitiveAtSiteSource
      setSensitiveAtSiteSource(sourceValue || '')
    } else {
      setSensitiveAtSiteSource('')
    }
  }, [item.sensitive_at_site_source, item.sensitiveAtSiteSource, item.sensitive_at_site, item.sensitiveAtSite])

  function shouldValidateField(fieldName) {
    if(qualificationReason && qualificationReason.length === 0){
      return checkFields[fieldName]
    }
    return true
  }

  const hasValidationRun = Boolean(siteProposalFieldValidation?.updated)

  const handleToggleSensitiveAtSite = () => {
    if (disabled) {
      return
    }
    const newValue = !sensitiveAtSite
    setSensitiveAtSite(newValue)

    // When toggling off, clear source locally and on the backend
    if (!newValue) {
      setSensitiveAtSiteSource('')
      requestUpdateSiteSpecie(
        item.id,
        params.siteHistoryId,
        item.historyId,
        {
          sensitiveAtSite: newValue,
          sensitiveAtSiteSource: null,
          reassessDateStatus: true
        }
      ).then(() => getSiteSpecie()).catch(() => getSiteSpecie())
      return
    }

    // The actual requirement will be enforced on propose via backend validation.
    // We still persist the toggle state with the current (possibly empty) source value.
    const trimmedSource = sensitiveAtSiteSource ? sensitiveAtSiteSource.trim() : null
    requestUpdateSiteSpecie(
      item.id,
      params.siteHistoryId,
      item.historyId,
      {
        sensitiveAtSite: newValue,
        sensitiveAtSiteSource: trimmedSource,
        reassessDateStatus: true
      }
    ).then(() => {
      getSiteSpecie()
    }).catch(() => {})
  }

  const handleChangeSensitiveAtSiteSource = (e) => {
    const value = e.target.value
    setSensitiveAtSiteSource(value)

    // Debounce backend updates so typing feels smooth and consistent with other
    // autosaving text fields (which also use a short delay before saving).
    const trimmedValue = value ? value.trim() : null

    updateSensitiveSourceTimeOut(() => {
      requestUpdateSiteSpecie(
        item.id,
        params.siteHistoryId,
        item.historyId,
        {
          sensitiveAtSite,
          sensitiveAtSiteSource: trimmedValue,
          reassessDateStatus: true
        }
      ).catch(() => {})
    })
  }

  return (
    <>
      <Container>
        <Row>
          <Col md={8} mdOffset={2}>
            <AssessmentPageTittleWrapper marginBottom={(item.lastReassessmentDate !== null && site.reassessmentFlag) ? '64px' : '0px'}>
              <AssessmentPageTittle data-test='legend'>
                <FormattedMessage id='assessment' />
              </AssessmentPageTittle>
              <AssessmentPageSubTittleWrapper>
                <AssessmentPageSubTittle>
                  <FormattedMessage id='speciesAssessmentSubTittle' />
                </AssessmentPageSubTittle>
                <Tooltip
                  style={{ zIndex: 1000 }}
                  zIndex='1070'
                  placement='bottom'
                  trigger={['hover']}
                  align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                  overlay={{ label: 'assessment', infoTooltip: 'speciesAssessmentSubTittleHint' }}
                >
                  <AssessmentPageSubTittleIconWrapper>
                    <InfoIcon />
                  </AssessmentPageSubTittleIconWrapper>
                </Tooltip>
              </AssessmentPageSubTittleWrapper>
            </AssessmentPageTittleWrapper>
          </Col>
        </Row>
      </Container>
      {renderParametersList}
      {parameterList.length < maximumParameterListLength && (
        <SpeciesDetailsContainer>
          <SpeciesDetailsAddParameter onClick={addParameter} disabled={disabled}>
            <AddNewIcon />
            <FormattedMessage id='newParameter' />
          </SpeciesDetailsAddParameter>
        </SpeciesDetailsContainer>
      )}
      <SpeciesDetailsContainer>
        <div style={{ width: '100%' }}>
          <div style={{ marginBottom: '16px' }}>
            <Checkbox
              label={
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FormattedMessage id='sensitiveAtSiteLabel' />
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    zIndex='1070'
                    placement='bottom'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: 'sensitiveAtSiteLabel', infoTooltip: 'sensitiveAtSiteHint' }}
                  >
                    <AssessmentPageSubTittleIconWrapper>
                      <InfoIcon />
                    </AssessmentPageSubTittleIconWrapper>
                  </Tooltip>
                </span>
              }
              checked={Boolean(sensitiveAtSite)}
              onChange={handleToggleSensitiveAtSite}
              field='sensitiveAtSite'
              disabled={disabled}
            />
          </div>
          <Textarea
            value={sensitiveAtSiteSource}
            onChange={handleChangeSensitiveAtSiteSource}
            placeholder='sensitiveAtSiteSourcePlaceholder'
            label={
              <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <FormattedMessage id='sensitiveAtSiteSource' />
                {sensitiveAtSite && <span style={{ color: '#d32f2f' }}>*</span>}
              </span>
            }
            infoTooltip='sensitiveAtSiteSourceHint'
            field='sensitiveAtSiteSource'
            height='128px'
            disabled={disabled || !sensitiveAtSite}
            zIndex='1070'
            /* Show error only after a validation run (e.g. after clicking Propose),
               when the species is marked sensitive at this site and the explanation
               is still empty. */
            error={
              hasValidationRun && sensitiveAtSite && !sensitiveAtSiteSource?.trim()
                ? { field: 'sensitiveAtSiteSource', error: 'sensitiveAtSiteSourceRequired' }
                : { field: '', error: '' }
            }
          />
        </div>
      </SpeciesDetailsContainer>
      {(item.lastReassessmentDate !== null && site.reassessmentFlag) && (
        <SpeciesDetailsContainer>
          <MultiSelectionDropdown
            value={qualificationReason}
            saveChanges={handleChangeQualificationReason}
            valueChecked={handleChangeValueChecked}
            label='triggerLabel'
            infoTooltip='triggerLabelHint'
            field='qualificationReasonSpecies'
            marginBottom='64px'
            menuWidth='416px'
            secondStepOptions={checkedOptions}
            placeholder='specieTriggerPlaceholder'
            fullWidthSelect={true}
            zIndex='1070'
            error={
              shouldValidateField('qualificationReasonSpecies')
                ? {
                    field: '',
                    error: ''
                  }
                : { field: 'qualificationReasonSpecies', error: 'pleaseCompleteThisField' }
            }
          />
        </SpeciesDetailsContainer>
      )}
      <SpeciesDetailsContainer>
        <div style={{ width: '100%' }}>
          <div style={{ marginBottom: '16px' }}>
            <Checkbox
              label={
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FormattedMessage id='sensitiveAtSiteLabel' />
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    zIndex='1070'
                    placement='bottom'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: 'sensitiveAtSiteLabel', infoTooltip: 'sensitiveAtSiteHint' }}
                  >
                    <AssessmentPageSubTittleIconWrapper>
                      <InfoIcon />
                    </AssessmentPageSubTittleIconWrapper>
                  </Tooltip>
                </span>
              }
              checked={Boolean(sensitiveAtSite)}
              onChange={handleToggleSensitiveAtSite}
              field='sensitiveAtSite'
              disabled={disabled}
            />
          </div>
          <Textarea
            value={sensitiveAtSiteSource}
            onChange={handleChangeSensitiveAtSiteSource}
            placeholder='sensitiveAtSiteSourcePlaceholder'
            label={
              <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <FormattedMessage id='sensitiveAtSiteSource' />
                {sensitiveAtSite && <span style={{ color: '#d32f2f' }}>*</span>}
              </span>
            }
            infoTooltip='sensitiveAtSiteSourceHint'
            field='sensitiveAtSiteSource'
            height='128px'
            disabled={disabled || !sensitiveAtSite}
            zIndex='1070'
            error={sensitiveAtSiteSourceError}
          />
        </div>
      </SpeciesDetailsContainer>
      <SpeciesDetailsContainer>
        <div style={{ width: '100%' }}>
          {(item.lastReassessmentDate !== null && site.reassessmentFlag) && (
            <Textarea
              value={reassessmentRational}
              onChange={handleChangeReassessmentRational}
              placeholder='justificationNoChangeSpeciePlaceholder'
              label='justificationNoChange'
              infoTooltip='qualificationReasonHint'
              field='rationalForReassessmentSpecies'
              height='128px'
              disabled={disabled}
              zIndex='1070'
            />
          )}
        </div>
        <div style={{ height: '150px', width: '100%' }} />
      </SpeciesDetailsContainer>
    </>
  )
}

export default SpeciesDetailsAssessmentForm
